<script setup lang="ts">
import BootstrapAlert from '@/components/bootstrap/BootstrapAlert.vue';
import ButtonContent from '@/components/devextreme/ButtonContent.vue';
import { RoleGroups } from '@/constants/Roles';
import Icons from '@/constants/Icons';
import DxButton from 'devextreme-vue/button';
import { DxColumn, DxDataGrid, DxToolbar, DxItem } from 'devextreme-vue/data-grid';
import { dataSource } from '@/services/api/roleService';
import { shallowRef } from 'vue';

definePage({
  name: 'MaintenanceRoles',
  meta: {
    title: 'maintenance.tabs.roles',
    roles: RoleGroups.Maintenance
  }
});

const rolesGridRef = shallowRef<DxDataGrid>();
</script>

<template>
  <DxDataGrid id="rolessGrid" :data-source="dataSource" ref="rolesGridRef">
    <DxToolbar>
      <DxItem location="before" template="title-template" />
      <DxItem location="before" template="read-only-template" :locate-in-menu="'auto'" />
      <DxItem location="after" template="refresh-button-template" />
      <DxItem location="after" name="searchPanel" :locate-in-menu="'auto'" />
    </DxToolbar>

    <DxColumn :sort-index="0" :sort-order="'asc'" data-field="name" />
    <DxColumn type="adaptive" :visible="false" />

    <template #title-template>
      <span class="h3 fw-semibold">{{ $t('maintenance.maintain', { entities: $t('maintenance.tabs.roles') }) }}</span>
    </template>

    <template #read-only-template>
      <BootstrapAlert type="info" css-class="px-3 py-2">
        <span>{{ $t('common.readOnly') }}</span>
      </BootstrapAlert>
    </template>

    <template #refresh-button-template>
      <DxButton type="primary" @click="rolesGridRef?.instance?.refresh()">
        <ButtonContent :icon="Icons.ArrowsRotate" />
      </DxButton>
    </template>
  </DxDataGrid>
</template>

<style scoped>

</style>